// extracted by mini-css-extract-plugin
export var buttonContainer = "_6j-1";
export var fontSizeSelect = "_6j-3";
export var formatSelect = "_6j-2";
export var formats = "_6j-4";
export var hidden = "_6j-5";
export var icon = "_6j-6";
export var select = "_6j-0";